import { render, staticRenderFns } from "./Certified.vue?vue&type=template&id=4bd3a5de&"
import script from "./Certified.vue?vue&type=script&lang=js&"
export * from "./Certified.vue?vue&type=script&lang=js&"
import style0 from "./Certified.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports